import {Tooltip as AntTooltip} from "antd";
import { string } from 'prop-types';
import {Box} from "theme-ui";
import {QuestionCircleFill} from "@styled-icons/bootstrap/QuestionCircleFill";
import React from 'react';

function Tooltip({ text }) {
  return (
    <AntTooltip title={text ?? 'Coming Soon'}>
      <Box as="span" ml="10px">
        <QuestionCircleFill width="18px" color="#074078" />
      </Box>
    </AntTooltip>
  );
}

Tooltip.propTypes = {
  text: string,
};

export default Tooltip;
